// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/pencil-line.js';

import { paths } from '../generated/pencil-line';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('pencil-line', Original, paths);
